import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const TableHead: FunctionComponent<TParentComponentProps> = (props) => {
  return <ParentComponent {...props} />;
};

TableHead.defaultProps = {
  defaultClassName: 'cart-table__head',
  as: 'thead',
};

export default TableHead;
